const OPTIONS = {
  root: null,          // observe relative to document viewport
  rootMargin: '400px', // trigger src switch at 400px above observed elements
  threshold: [0, 1.0]  // respond when image crosses threshold either a little or completely
};

// small polyfill for Microsoft Edge 15 isIntersecting property
// see https://github.com/WICG/IntersectionObserver/issues/211#issuecomment-309144669
// and https://stackoverflow.com/a/49352038/1228411
if ('IntersectionObserver' in window &&
  'IntersectionObserverEntry' in window &&
  'intersectionRatio' in window.IntersectionObserverEntry.prototype &&
  !('isIntersecting' in IntersectionObserverEntry.prototype)) {

  Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
    get: function () {
      return this.intersectionRatio > 0;
    }
  });
}

function observerCallback(callback, entries, self) {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) {
      callback(entry.target);
      self.unobserve(entry.target);
    }
  });
}

/**
 * If browser/version supports IntersectionObserver:
 * loads image or video when user scrolls to within a given value (rootMargin) of the image/video
 */
let observer;
export function setupWithObserver(elements, callback) {
  observer = new IntersectionObserver(observerCallback.bind(this, callback), OPTIONS);
  Array.from(elements).forEach(el => observer.observe(el));
}

/**
 * If browser/version does not support IntersectionObserver:
 * just load all images after document load
 */
export function setupWithoutObserver(elements, callback) {
  Array.from(elements).forEach(callback);
}

/**
 * Sets up an InteractionObserver on the given elements with a callback returned for each
 * element as it comes into view.
 * @param {NodeList, Array} elements - The elements to observe
 * @param {Function} cb - The callback function which receives each image as its param
 */
export default function setupObserver(elements, cb) {
  if ('IntersectionObserver' in window && window.IntersectionObserver !== undefined) {
    setupWithObserver(elements, cb);
  } else {
    setupWithoutObserver(elements, cb);
  }
}
